import { medtechApiClient } from '.';
import { Group } from './model/group';

export const GroupApi = {
  fetchGroups: () => {
    return medtechApiClient.get<Group[]>('groups').then(({ data }) => data);
  },
};
